module.exports = __webpack_public_path__ + "static/media/5@3x.cea067b1.png";